module.exports = __webpack_public_path__ + "static/media/IMG_4916.b978ef79.JPG";